import React from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { listLanguage } from '../../../../../configs/LanguageConfig';
import { REDUCER_NAME } from './../../../sidebar/reducer';

const accountRole = {
  premium: 'FiinTrade.Premium',
  standard: 'FiinTrade.Standard',
  trial: 'FiinTrade.Trial',
};

const LINK_TARGET = 'https://web.fiintrade.vn/chinh-sach-gia/';
const LINK_TARGET_EN = 'https://web.fiintrade.vn/en/pricing/';

class Membership extends React.Component {
  redirectToFiingroup = () => {
    const { i18n } = this.props;
    const link = i18n.locale === listLanguage.en ? LINK_TARGET_EN : LINK_TARGET;
    const win = window.open(link, '_blank');
    win.focus();
  };

  renderButton = (titleButton, isEnable) => {
    return (
      <div
        className={
          isEnable ? `button-change-account` : `button-change-account-disable`
        }
        onClick={isEnable ? this.redirectToFiingroup : null}
      >
        <Translate value={titleButton} />
      </div>
    );
  };

  render() {
    const { userInfo } = this.props;
    return (
      <div className="body-user-info">
        <div className="row-myprofile">
          <Translate value={`systemSetting.userInfo.memberShip`} />
        </div>
        <div className="div-member-ship">
          <div className="left-info">
            <div className="row-left-info">
              <span>
                <Translate value={`systemSetting.userInfo.usingAcc`} />
              </span>
              <span style={{ color: '#ffc859' }}>
                {`${userInfo.profile.list_package
                  .toString()
                  .replace('.', ' ')} Account`}
              </span>
            </div>
            <div className="row-left-info">
              <span>
                <Translate value={`systemSetting.userInfo.endAcc`} />
              </span>
              <span>{userInfo.profile.end_date}</span>
            </div>
          </div>
          <div className="right-button">
            {this.renderButton(
              `systemSetting.userInfo.reNew`,
              userInfo.profile.list_package === accountRole.premium,
            )}
            {this.renderButton(
              `systemSetting.userInfo.upgrade`,
              userInfo.profile.list_package === accountRole.trial,
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userInfo: state[REDUCER_NAME].userInfo.userInfoSystem,
    i18n: state.i18n,
  };
};

export default connect(mapStateToProps)(Membership);
